import type * as ContentHeader from '../types/ContentHeader'
import { imageParser } from '../props/parsers/Image'
import heroStatsParser from '../props/parsers/HeroStats'

export default function contentHeaderComponentParser(
  rawComponent: ContentHeader.Raw,
): ContentHeader.Parsed {
  const { image, heroStats, modalVideo, ...rest } = rawComponent.contentHeader

  let props

  if (image) {
    props = {
      ...heroStatsParser(heroStats),
      ...imageParser(image),
      ...rest,
    }
  } else {
    props = {
      ...heroStatsParser(heroStats),
      ...rest,
    }
  }

  if (modalVideo && modalVideo.displayVideo) {
    const [videoId] = modalVideo.videoPath.split('=').reverse()
    props.modalVideo = {
      modalLinkText: modalVideo.modalLinkText,
      videoId: videoId,
    }
  }

  return {
    name: 'ContentHeader',
    props,
  }
}
